import { render } from "./WhoPrevDepartment.vue?vue&type=template&id=3f96a756"
import script from "./WhoPrevDepartment.vue?vue&type=script&lang=js"
export * from "./WhoPrevDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__